// extracted by mini-css-extract-plugin
module.exports = {"divider":"Splitter_divider__1-V_T","root":"Splitter_root__39UQ7","panel":"Splitter_panel__12M4V"};